import moment from 'moment';

const searchInteraction = ({
  startDate,
  endDate,
  numAdults,
  children = [],
  specialCodeValue,
}) => {
  if (!window.dataLayer) return;

  const startMoment = moment(startDate);
  const endMoment = moment(endDate);
  const nights = endMoment.diff(startMoment, 'days');

  const data = {
    event: 'searchInteraction',
    ArrivalDt: startDate,
    DepartDt: endDate,
    AdultQty: numAdults,
    ChildQty: children.length,
    NightsQty: nights,
    SpecialCode: specialCodeValue,
  };

  window.dataLayer.push(data);
};
export default searchInteraction;
